import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconUserEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUserEdit"><Path d="M11 20.5H4.5V19.5C4.5 15.3579 7.85786 12 12 12" stroke="currentColor"/><Circle cx="12" cy="7.5" r="4.5" stroke="currentColor"/><Path d="M13.5 20.5V18L17.75 13.75C18.4404 13.0596 19.5596 13.0596 20.25 13.75C20.9404 14.4404 20.9404 15.5596 20.25 16.25L16 20.5H13.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconUserEdit;
